var exports = {
  "k": "xdbfd91f1--66de0b--container",
  "I": "xdbfd91f1--66de0b--comment",
};

module.exports = exports;
